var _desc, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthorizeKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.001 90 c -0.793 0 -1.557 -0.314 -2.122 -0.879 c -0.614 -0.614 -0.932 -1.466 -0.871 -2.333 l 0.894 -12.645 c 0.051 -0.721 0.36 -1.399 0.872 -1.909 l 31.95 -31.95 c -4.443 -10.84 -2 -23.348 6.387 -31.735 c 11.396 -11.397 29.943 -11.399 41.341 0 c 11.397 11.398 11.397 29.944 0 41.341 l 0 0 c -8.387 8.387 -20.895 10.83 -31.735 6.388 l -7.111 7.11 c -0.455 0.456 -1.045 0.752 -1.682 0.847 l -6.952 1.028 l -1.028 6.937 c -0.194 1.308 -1.221 2.335 -2.529 2.529 l -6.936 1.028 l -1.028 6.951 c -0.094 0.638 -0.391 1.228 -0.846 1.683 l -3.838 3.838 c -0.511 0.511 -1.189 0.82 -1.91 0.871 L 3.212 89.992 C 3.141 89.997 3.071 90 3.001 90 z M 6.809 75.684 l -0.571 8.078 l 8.078 -0.57 l 2.344 -2.345 l 1.209 -8.173 c 0.193 -1.309 1.22 -2.335 2.529 -2.53 l 6.937 -1.028 l 1.028 -6.937 c 0.194 -1.308 1.221 -2.335 2.529 -2.529 l 8.174 -1.208 l 7.878 -7.877 c 0.913 -0.914 2.305 -1.14 3.462 -0.563 c 8.954 4.473 19.726 2.721 26.805 -4.358 c 9.057 -9.058 9.057 -23.797 0 -32.855 c -9.059 -9.058 -23.797 -9.057 -32.856 0 c -7.078 7.078 -8.829 17.85 -4.356 26.805 c 0.577 1.155 0.35 2.549 -0.563 3.462 L 6.809 75.684 z M 79.331 47.768 h 0.01 H 79.331 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.433 33.321 c -2.605 0 -5.054 -1.015 -6.897 -2.857 c -1.843 -1.842 -2.858 -4.292 -2.858 -6.897 s 1.015 -5.055 2.858 -6.898 c 1.842 -1.842 4.292 -2.857 6.897 -2.857 c 2.606 0 5.055 1.015 6.898 2.857 c 3.802 3.803 3.802 9.992 0 13.795 v 0 C 71.489 32.307 69.039 33.321 66.433 33.321 z M 71.209 28.343 h 0.01 H 71.209 z M 66.433 19.813 c -1.002 0 -1.945 0.391 -2.654 1.099 c -0.709 0.71 -1.1 1.652 -1.1 2.654 s 0.391 1.945 1.1 2.654 c 1.418 1.418 3.888 1.418 5.308 0 l 0 0 c 1.463 -1.464 1.463 -3.845 0 -5.308 C 68.379 20.204 67.436 19.813 66.433 19.813 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizeKey);
export default __webpack_public_path__ + "static/media/authorizeKey.ea4189dbeaddf674de8a446d83ca661e.svg";
export { ForwardRef as ReactComponent };